import { render, staticRenderFns } from "./qiandao.vue?vue&type=template&id=80492114&scoped=true"
import script from "./qiandao.vue?vue&type=script&lang=js"
export * from "./qiandao.vue?vue&type=script&lang=js"
import style0 from "./qiandao.vue?vue&type=style&index=0&id=80492114&prod&lang=css"
import style1 from "./qiandao.vue?vue&type=style&index=1&id=80492114&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80492114",
  null
  
)

export default component.exports